import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './KeyUseCasesRota.css';

const useCases = [
  {
    icon: '/images/protect.png',
    title: 'Hospital Admins',
    desc: 'Hands-free notes, real-time transcription in multiple languages.'
  },
  {
    icon: '/images/protect.png',
    title: 'NHS Trust Managers',
    desc: ''
  },
  {
    icon: '/images/Rural.png',
    title: 'Rural/Small Clinics',
    desc: ''
  },
  {
    icon: '/images/Telemedicine.png',
    title: 'Mobile Health Units',
    desc: ''
  },
  {
    icon: '/images/Ngoroata.png',
    title: 'NGOs',
    desc: ''
  },
];

const KeyUseCasesRota = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-20% 0px -20% 0px' });
  return (
    <motion.section
      className="keyusecases-roata-section"
      ref={ref}
      initial={{ opacity: 0, y: 80 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="keyusecases-roata-container" id="keyusecases-roata-container">
        <div className="keyusecases-roata-left">
          <img 
            src="/images/Herosecimg.gif" 
            alt="Genix Roata Use Case" 
            className="keyusecases-roata-mainimg"
          />
        </div>
        <div className="keyusecases-roata-right">
          <h2 className="keyusecases-roata-title">Key Use Cases</h2>
          <p className="keyusecases-roata-subtitle">See how Genix AI fits into real-world care.</p>
          <div className="keyusecases-roata-cards">
            {useCases.map((uc, idx) => (
              <div className="keyusecases-roata-card" key={uc.title}>
                <img src={uc.icon} alt={uc.title} className="keyusecases-roata-icon" />
                <div>
                  <div className="keyusecases-roata-card-title">{uc.title}</div>
                  {uc.desc && <div className="keyusecases-roata-card-desc">{uc.desc}</div>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default KeyUseCasesRota; 